<template>
    <div class="branded-card-attributes">
        <span v-if="title" class="branded-card-attributes-title">{{ title }}</span>
        <Attribute
            v-for="(attribute, index) in sortedAttributes"
            :key="index"
            :attribute="attribute"
            :highlightIncluded="highlightIncluded" />
    </div>
</template>

<script lang="ts">
    import { PropType, computed } from 'vue';
    import orderBy from 'lodash/orderBy';
    import { BrandedAttributeItem } from '@ui/components/BrandedFares/BrandedCard/BrandedCard.interfaces';
    import { FlightBrandedAttributeStatus } from '@shared/interfaces/brandedFares';
    import Attribute from './Attribute/Attribute.vue';

    export default {
        name: 'BrandedAttributes',
        components: {
            Attribute,
        },
        props: {
            attributes: { type: Array as PropType<BrandedAttributeItem[]>, required: true },
            highlightIncluded: {
                type: Boolean,
                default: false,
            },
            title: String,
        },
        setup(props) {
            const sortPriority = [
                FlightBrandedAttributeStatus.Included,
                FlightBrandedAttributeStatus.NotOffered,
                FlightBrandedAttributeStatus.Chargeable,
            ];

            const sortedAttributes = computed<BrandedAttributeItem[]>(() =>
                orderBy(
                    props.attributes.map((attr, index) => ({ ...attr, index })),
                    [(attr) => sortPriority.findIndex((s) => s === attr.status), 'index'],
                    ['asc', 'asc']
                ).map(({ status, description }) => ({ status, description }))
            );

            return { sortedAttributes };
        },
    };
</script>
<style lang="scss" scoped>
    @forward './Attributes.scss';
</style>
